export default __webpack_public_path__ + "static/media/LOreal-Logo-1962-present-removebg-preview.a31f3910.png";